<template>
<div id="ui-view">
  <div>
    <div class="card">
      <div class="card-header">
        <span class="title_head">Sales Receipt</span>
        <a href="#" class="float-right"></a>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group>
              <label for="name">Select Customer <span style="color: red;">*</span></label>
              <div class="row">
                <div class="col-md-10">
                  <model-list-select :list="customer_name" option-value="customer_id" option-text="cust_cmp_name" v-model="selectcustomer" placeholder="Search Customer" @input="CusSelected()" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>
                  <small class="form-text text-muted" v-if="haserror.customer!=''"><strong style="color: red;">{{haserror.customer}}</strong></small>
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
        
        <div style="background-color: rgb(232, 235, 238); padding-left: 18px; padding-top: 10px; padding-bottom: 25px;">
          <div class="row">
            <div class="col-md-2">
              <label for="Purches">Sales Id <span style="color:red"> *</span></label>
            </div>
            <div class="col-md-3">
              <label for="Customer">Customer Id</label>
            </div>
            <div class="col-md-2">
              <label>Amount To Pay</label>
            </div>
            <div class="col-md-5">
              <label>Balance</label>
            </div>
          </div>

          <div class="row" v-for="(row, index) in rows1">
            <div class="col-md-2">
              <div class="row">
                <div class="col-md-10">
                  <label for="Purches"></label>
                  <input type="text" name="sales_id" class="form-control" v-model="row.sales_id" v-on:change="sales(index);" autocomplete="off"  placeholder="Enter Sale Id">
                  <small class="form-text text-muted" v-if="row.err_sales_id!=''"><strong style="color: red;">{{row.err_sales_id}}</strong></small>
                </div>
                <div class="col-md-2" style="padding-left: 0px; padding-top: 20px;">
                  <button type="button" @click="search_sales_modal(index)" class="btn btn-pill" v-b-tooltip.hover title="Search Sales Id"><i class="fa fa-search"></i></button>
                </div>

              </div>
            </div>
            <div class="col-md-3">
              <label for="customer_id"></label>
              <input type="text" name="customer_id" autocomplete="off"  class="form-control" readonly v-model="row.customer_id">
            </div>
            <div class="col-md-2">
              <label></label>
              <input type="text" name="amount_topay" autocomplete="off"  class="form-control" v-model="row.amount_topay" v-on:change="calculate(index);">
              
            </div>
            <div class="col-md-5">
              <div class="row">
                <div class="col-md-8">
                  <label></label>
                  <input type="text" name="amount_balance" autocomplete="off"  class="form-control" readonly v-model="row.amount_balance">
                </div>
                <div class="col-md-2" style="padding-top: 20px;">
                  <button type="button" @click="addRow1" class="btn btn-pill" v-b-tooltip.hover title="Add New Row"><i class="fa fa-plus"></i></button>
                </div>
                <div class="col-md-2" v-if="(index != 0)" style="padding-top: 20px; padding-left:0px; ">
                  <button type="button" v-on:click="removeElement(index);" class="btn btn-pill" v-b-tooltip.hover title="Delete Row"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="row" style="padding-top: 10px;">
            <div class="col-md-3">
              <div class="form-group">
                <label>Payment Mode</label>
                <model-list-select :list="payment_mode_list" option-value="pay_value" option-text="pay_text" v-model="payment_mode" @input="onSelect()" placeholder="Select Payment Mode"></model-list-select>
                <small class="form-text text-muted" v-if="haserror.payment_mode!=''"><strong style="color: red;">{{haserror.payment_mode}}</strong></small>
              </div>
            </div>
            <div class="col-md-3" v-if="is_cheque">
              <div class="form-group">
                <label>Cheque No</label>
                <input type="text" name="cheque_no" autocomplete="off"  v-model="cheque_no" class="form-control" placeholder="Enter Cheque No">
                <small class="form-text text-muted" v-if="haserror.cheque_no!=''"><strong style="color: red;">{{haserror.cheque_no}}</strong></small>
              </div>
            </div>
            <div class="col-md-3" v-if="is_cheque">
              <div class="form-group">
                <label>Cheque Date</label><br>
                <date-picker v-model="cheque_date" editable lang="en"></date-picker>
                <small class="form-text text-muted" v-if="haserror.cheque_date!=''"><strong style="color: red;">{{haserror.cheque_date}}</strong></small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="name">Attachment </label>
                <input :class="{'is-invalid':haserror.attachment}" autocomplete="off"  type="file" class="form-control filesize" name="attachment" id="attachment">
                <small class="form-text text-muted" v-if="haserror.attachment!=''"><strong style="color: red;">{{haserror.attachment}}</strong></small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Note </label>
              <textarea type="textarea" class="form-control" v-model="note"></textarea>
              <small class="form-text text-muted" v-if="haserror.note!=''"><strong style="color: red;">{{haserror.note}}</strong></small>
            </div>
          </div>
        </div>
        <div class="card-footer"><button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit"><i class="fa fa-dot-circle-o"></i> Save</button></div>
      </div>
    </div>

    <b-modal title="Search" no-close-on-esc no-close-on-backdrop hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
      <b-row>
        <b-col sm="3">
          <b-form-group>
            <label for="name"> From Date </label>
            <date-picker editable lang="en" v-model="from_DT" style="width: 120px;"></date-picker>
          </b-form-group>
        </b-col>
        <b-col sm="3">
          <b-form-group>
            <label for="name">To Date </label>
            <date-picker editable lang="en" v-model="to_DT" style="width: 120px;"></date-picker>
          </b-form-group>
        </b-col>
         <b-col sm="6">
          <b-form-group>
            <label for="name">Sales Id </label>
            <b-form-input type="text" placeholder="Sales Id" autocomplete="off"  v-model="sales_id1"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-md-12">
          <center><button type="button" @click="search_sales" style="width: 110px; border-radius: 15px;" class="btn btn-pill">
          <i class="fa fa-search"></i>&nbsp;Search</button></center>
        </div>        
      </div>
      <br>
      <div class="card-header">
        <strong>List Sales</strong>
      </div>
      <div>
        <vue-good-table 
        :columns="columns" 
        :rows="rows" 
        mode="remote"
        ref="my-table"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="totalRecords"
        :pagination-options="{ enabled: true, perPage: 5}" 
        styleClass="vgt-table striped bordered table-sm condensed">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'paymod'">
              <a @click="add_sales_payment(props.row)" style="cursor: pointer;"><i class="fa fa-plus"></i> Add</a>          
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </b-modal>

  <Spinner v-if="loading"></Spinner>

  </div>
</template>

<script>
  import Spinner from '../../spinner.vue'
  import { VueEditor } from 'vue2-editor'
  import DatePicker from 'vue2-datepicker'
  export default {
    name:'ListPayments',
    components: {
      'date-picker':  DatePicker,Spinner
    },
    data () {
      return {
        is_cheque: false,
        allowableTypes: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
        maximumSize: 1000000,
        largeModal1:false,
        largeModal:false,
        loading:false,
        customer_name:[],
        selectcustomer:null,
        sales_row:'',
        sales_id1:'',
        from_DT : '',
        to_DT : '',
        payment_mode : 'cash',
        cheque_no : '',
        cheque_date : '',
        note:'',
        totalRecords: 0,
        serverParams: {
        columnFilters: {
                   },
        sort: {},
        page: 1, 
        perPage: 5
      },
        payment:{
          sales_id:'',
          customer_id:'',
          amount_topay:0,
          amount_balance:0,
        },
        haserror:{
          message:'',
          customer:'',
          attachment:'',
          cheque_no:'',
          cheque_date:'',
          note:'',
          payment_mode:''
        },
        payment_mode_list: [
          { pay_value: 'cash', pay_text: 'Cash'},
          { pay_value: 'cheque', pay_text: 'Cheque'},
          { pay_value: 'online', pay_text: 'Online'}
        ],
        columns: [
        {
          label: 'Sales ID',
          field: 'sales_id',
          width: '10% !important'
        },
        {
          label: 'Shop',
          field: 'est_shop_name',
          width: '15% !important',
        },
        {
          label: 'Customer Name',
          field: 'cust_cmp_name',
          width: '25% !important'
        },
        {
          label: 'Amount to Pay',
          field: 'total_amt_pay',
          width: '20% !important'
        },
        {
          label: 'Amount Balance',
          field: 'total_amt_pendingpay',
          width: '20% !important'
        },
        {
          label: 'Action',
          field: 'paymod',
          width: '10% !important'
        },
        ],
        rows:[],
        rows1:[]
      }
    },
    
    created(){
      this.searchcustomer()
      this.shopuser();
      for (var i = 0; i < 1; i++) {
        this.rows1.push({err_sales_id:'', sales_id:'', customer_id:'', amount_topay:0, amount:0, amount_balance:0})
      }
    },
    methods:{
    updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
  
           this.updateParams({page: params.currentPage});
           this.search_sales();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.search_sales();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.search_sales();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.search_sales();
    },

      onSelect(){
        if(this.payment_mode == 'cheque'){
          this.is_cheque = true
        }else{
          this.is_cheque = false
        }
      },
      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },
      attachment(callback){
        var _this = this
        const attachment = document.querySelector('#attachment');
        if(attachment.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', attachment.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData).then(function (response) {
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return '';
        }
      },
      searchcustomer(){
        this.haserror.customer = ''
        var _this = this
        this.$http.get('/api/customers').then(function (response){
          _this.customer_name=response.data
        }).catch(function (error) {
          console.log(error);  
        });
      },

      addRow1(){
        if(this.selectcustomer == null || this.selectcustomer.customer_id == undefined){
          var cust_cmp_name = null
        }else{
          var cust_cmp_name = this.selectcustomer.customer_id
        }
        this.rows1.push({err_sales_id:'', sales_id:'', customer_id:cust_cmp_name, amount_topay:0, amount:0, amount_balance:0})
      },

      removeElement: function(index) {
        this.rows1.splice(index, 1);
      },

      reset_error(){
        this.haserror.message=''
        this.haserror.customer=''
        this.haserror.attachment=''
        this.haserror.cheque_no=''
        this.haserror.cheque_date=''
        this.haserror.note=''
      },

      validation(boolean){
        var _this = this
        const attachment = document.querySelector('#attachment');
        this.reset_error()
        var submit_true = 0;
        var cheque_reg = /^\d+$/
        
        if(this.selectcustomer == null || this.selectcustomer.customer_id == undefined){
          this.haserror.customer = 'Required'
          submit_true = 1
        }

        if(this.cheque_no != ""){
          if(cheque_reg.test(this.cheque_no) == false){
            this.haserror.cheque_no = 'Invalid Cheque Number'
            submit_true = 1
          }else if(this.cheque_no.length > 20){
            this.haserror.cheque_no = 'Cheque number cannot be greater than 20'
            submit_true = 1
          }
        }

        if(this.note != ""){
          if(this.cheque_no.length > 500){
            this.haserror.cheque_no = 'Note cannot be greater than 500 characters'
            submit_true = 1
          }
        }

        if(attachment.files[0]!=undefined){
          if(attachment.files[0].size>this.maximumSize){
            this.haserror.attachment="File Size Cannot Be Greater Than 1 mb"
            submit_true=1
          }
          if(this.allowableTypes.indexOf(attachment.files[0].type.toLowerCase())=== -1){
            this.haserror.attachment="File type should be jpeg, jpg, png, pdf"
            submit_true=1
          }
        }

        if(this.payment_mode == ''){
          this.haserror.payment_mode = 'Required'
          submit_true = 1
        }

        for (var i = this.rows1.length-1; i >=0;  i--) {
          if(this.rows1[i].sales_id==''){
            submit_true = 1
            this.rows1[i].err_sales_id='Required'
          }else{
            this.rows1[i].err_sales_id=''
          }
        }

        return submit_true
      },

      finalsubmit(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        
        var submit_true = this.validation()
        var _this = this

        if(this.rows1.length==0){
          alert("nothing to Save");
        }else{
          if (submit_true==0) {
            this.loading=true 
            
            var num = /^[0-9]{1}$/

          if(this.cheque_date != ''){
            let date = new Date(this.cheque_date)
            var year = date.getFullYear()
            var month = date.getMonth()+1;
            var day = date.getDate();

            if(num.test(month)==true){
              var month='0'+month
            }else{
              var month=month
            }

            if(num.test(day)==true){
              var day='0'+day
            }else{
              var day=day
            }
            
            var dateval = year+'-'+month+'-'+day
          }else{
            var dateval = null
          }

            var pay = {};
              Promise.all([this.attachment()]).then(file=>{
                pay.customer_id = this.selectcustomer.customer_id
                pay.payment_row = this.rows1
                pay.attachment = file[0]
                pay.cheque_no = this.cheque_no 
                pay.cheque_date = dateval
                pay.note = this.note
                pay.payment_mode = this.payment_mode
                // console.log(pay)
                this.$http.post('/api/salepayments/addpayment', pay).then(function (response) {
                  _this.loading=false;
                  _this.reset_form()
                  _this.haserror.message = 'Payment Added Successfully';
                  setTimeout(function(){ _this.haserror.message='';}, 2000);
                })
                .catch(function (error) {
                  _this.loading=false
                });
            });
          }
        }
      },

      CusSelected(){
        this.rows = []
        this.haserror.customer = ''
        if(this.rows1.length > 0){
          for(var i=0; i<this.rows1.length; i++){
            this.rows1[i]['sales_id'] = ''
            this.rows1[i]['customer_id'] = this.selectcustomer.customer_id
            this.rows1[i]['amount_topay'] = 0
            this.rows1[i]['amount_balance'] = 0
          }
        }        
      },

      search_sales(){
        var _this=this
        var data = [];

        var sales_id = this.sales_id1
        //var from_DT = this.from_DT
        //var to_DT = this.to_DT
        var customer_id = this.selectcustomer.customer_id
        var num=/^[0-9]{1}$/
        let filteParam = {};
        var customerid = this.selectcustomer.customer_id
        filteParam.page = this.serverParams.page;
        filteParam.perPage = this.serverParams.perPage;
        filteParam.sort = this.serverParams.sort;
        if(this.to_DT)
        { 
         var dateto = new Date(this.to_DT)
         var year=dateto.getFullYear()
         var month=dateto.getMonth()+1;
         var day=dateto.getDate();
 
         if(num.test(month)==true){
           var month='0'+month
         }else{
           var month=month
         }
 
         if(num.test(day)==true){
           var day='0'+day
         }else{
           var day=day
         }
         var  todate1=year+'-'+month+'-'+day
       }else{todate1=''}

       if(this.from_DT)
       {
        var datefrom= new Date(this.from_DT)
        var year1=datefrom.getFullYear()
        var month1=datefrom.getMonth()+1;
        var daycon=datefrom.getDate();
        if(num.test(month1)==true){
          var month1='0'+month1
        }else{
          var month1=month1
        }

        if(num.test(daycon)==true){
          var day1='0'+daycon
        }else{
          var day1=daycon
        }
        var  fromdate1=year1+'-'+month1+'-'+day1
      }else{fromdate1=''}
      
        data = data+"&filter[where][customer_id]="+this.selectcustomer.customer_id
        data = data+"&filter[where][sales_id]="+sales_id
        data = data+"&filter[where][from_DT]="+fromdate1
        data = data+"&filter[where][to_DT]="+todate1

        this.$http.get('/api/salepayments/sales_search?params='+JSON.stringify(filteParam)+data)
        .then(function(response){
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          _this.rows=response.data;

        }).catch(function(error){
          console.log(error)
        })

      },

      sales(index){

        this.rows1[index].err_sales_id=''
        if(this.selectcustomer == null || this.selectcustomer.customer_id == undefined){
          this.haserror.customer = 'Select Customer First'
          this.rows1[index]['sales_id'] = ''
        }else{

          var match = 0;
          for(var i=0; i<this.rows1.length; i++){
            if(i != index){
              if(this.rows1[i]['sales_id'] === this.rows1[index]['sales_id']){
                match = 1;
              }
            }
          }

          if(match == 0){
            this.haserror.customer = '';
            var _this = this;
            var data = {};
            data.sales_id = this.rows1[index]['sales_id']
            data.customer_id = this.selectcustomer.customer_id
            this.$http.post('/api/salepayments/customer_payment',data).then(function (response){
              if(response.data.length > 0){
                _this.rows1[index]['sales_id'] = response.data[0].sales_id
                _this.rows1[index]['customer_id'] = _this.selectcustomer.customer_id
                // _this.rows1[index]['customer_id'] = _this.selectcustomer.cust_cmp_name
                _this.rows1[index]['amount_topay'] = response.data[0].total_amt_pendingpay
                _this.rows1[index]['amount'] = response.data[0].total_amt_pendingpay
                _this.rows1[index]['amount_balance'] = 0
              }else{
                _this.rows1[index]['sales_id'] = ''
                _this.rows1[index]['customer_id'] = ''
                _this.rows1[index]['amount_topay'] = 0
                _this.rows1[index]['amount_balance'] = 0
              }
            }).catch(function (error) {
              console.log(error);  
            });
          }else{
            this.rows1[index].err_sales_id = 'This sales id already used'
            this.rows1[index]['sales_id'] = ''
          }
        }
      },

      calculate(index){
        this.rows1[index].err_sales_id = ''
        if(parseFloat(this.rows1[index]['amount_topay']) > parseFloat(this.rows1[index]['amount'])){
          this.rows1[index]['amount_topay'] = this.rows1[index]['amount']
          this.rows1[index].err_sales_id = 'Amount cannot be greater than '+ this.rows1[index]['amount']
        }else if(parseFloat(this.rows1[index]['amount_topay']) < 0){
          this.rows1[index]['amount_topay'] = this.rows1[index]['amount']
          this.rows1[index].err_sales_id = 'Amount cannot be negative'
        }else{
          var amt_pay = /^[1-9]\d*(\.\d+)?$/
          if(amt_pay.test(this.rows1[index]['amount_topay']) == false){
            this.rows1[index].err_sales_id = 'Enter valid amount'
            this.rows1[index]['amount_topay'] = 0
            this.rows1[index]['amount_balance'] = this.rows1[index]['amount']
          }else{
            if(this.rows1[index]['amount_topay'] == ''){
              this.rows1[index]['amount_topay'] = 0
              this.rows1[index]['amount_balance'] = this.rows1[index]['amount']
            }
            var bal_amt = parseFloat(this.rows1[index]['amount']) - parseFloat(this.rows1[index]['amount_topay'])
            this.rows1[index]['amount_balance'] = bal_amt.toFixed(6)
          }
        }
      },

      search_sales_modal(index){
        this.from_DT=''
        this.to_DT=''
        this.sales_id1=''
        this.rows=[]
        if(this.selectcustomer == null || this.selectcustomer.customer_id == undefined){
          this.haserror.customer = 'Select Customer First'
        }else{
          this.sales_row = index
          this.largeModal = true
        }
      },

      add_sales_payment(row){
        var sales_row = this.sales_row
        this.rows1[sales_row]['sales_id'] = row.sales_id
        this.sales(sales_row)
        this.largeModal = false
      },

      reset_form(){
        var _this = this
        if(_this.rows1.length > 0){
          for(var i=0;i<_this.rows1.length;i++){
            _this.rows1[i]['err_sales_id'] = '',
            _this.rows1[i]['sales_id'] = '',
            _this.rows1[i]['customer_id'] = '',
            _this.rows1[i]['amount_topay'] = 0,
            _this.rows1[i]['amount'] = 0,
            _this.rows1[i]['amount_balance'] = 0
          }
        }
        for (var j = this.rows1.length-1; j >= 1;  j--){
          this.rows1.splice(j,1);
        }
        _this.selectcustomer = null
        _this.payment_mode = 'cash'
        _this.cheque_no = ''
        _this.cheque_date = ''
        _this.note = ''
      }

    }
  }
</script>




// WEBPACK FOOTER //
// src/views/sales/salepayment.vue